<template>
  <div id="components-layout-demo-basic">
    <svg xmlns="http://www.w3.org/2000/svg" style="display: none;">
      <defs>
        <symbol id="icon-search" viewBox="0 0 427.83 427.94">
          <g id="layer1"><path id="circle2017" d="M192,0C86.17,0,0,86.17,0,192S86.13,384.13,192,384.13A190.78,190.78,0,0,0,311.58,342l80,79.92a21.38,21.38,0,0,0,30.25-30.21l-80-80A191.16,191.16,0,0,0,384,191.92c0-105.79-86.21-192-192-192Zm0,42.67A149.38,149.38,0,1,1,42.66,192.13q0-.08,0-.17A148.94,148.94,0,0,1,191.25,42.67Z" transform="translate(0.04 0.08)"/></g>
        </symbol>
        <symbol id="icon-edit" viewBox="0 0 459 459">
          <g>
            <path d="M0,362.1V459h96.9l280.5-283.05l-96.9-96.9L0,362.1z M451.35,102c10.2-10.2,10.2-25.5,0-35.7L392.7,7.649
              c-10.2-10.2-25.5-10.2-35.7,0l-45.9,45.9l96.9,96.9L451.35,102z"/>
          </g>
        </symbol>
        <symbol id="icon-team" viewBox="0 0 512 512">
          <g><circle cx="256" cy="119.631" r="87"/><circle cx="432" cy="151.63" r="55"/><circle cx="80" cy="151.63" r="55"/><path d="m134.19 256.021c-21.65-17.738-41.257-15.39-66.29-15.39-37.44 0-67.9 30.28-67.9 67.49v109.21c0 16.16 13.19 29.3 29.41 29.3 70.026 0 61.59 1.267 61.59-3.02 0-77.386-9.166-134.137 43.19-187.59z"/><path d="m279.81 241.03c-43.724-3.647-81.729.042-114.51 27.1-54.857 43.94-44.3 103.103-44.3 175.48 0 19.149 15.58 35.02 35.02 35.02 211.082 0 219.483 6.809 232-20.91 4.105-9.374 2.98-6.395 2.98-96.07 0-71.226-61.673-120.62-111.19-120.62z"/><path d="m444.1 240.63c-25.17 0-44.669-2.324-66.29 15.39 51.965 53.056 43.19 105.935 43.19 187.59 0 4.314-7.003 3.02 60.54 3.02 16.8 0 30.46-13.61 30.46-30.34v-108.17c0-37.21-30.46-67.49-67.9-67.49z"/></g>
        </symbol>
        <symbol id="icon-time" viewBox="0 0 426.667 426.667">
          <g><path d="M303.893,122.773L303.893,122.773c-25.067-24.96-57.813-37.44-90.56-37.44v128l-90.56,90.56c50.027,50.027,130.987,50.027,181.013,0C353.813,253.867,353.813,172.8,303.893,122.773z"/><path d="M213.333,0C95.467,0,0,95.467,0,213.333s95.467,213.333,213.333,213.333s213.333-95.573,213.333-213.333C426.667,95.467,331.2,0,213.333,0z M213.333,384c-94.293,0-170.667-76.373-170.667-170.667S119.04,42.667,213.333,42.667S384,119.04,384,213.333S307.627,384,213.333,384z"/></g>
        </symbol>
        <symbol id="icon-fte" viewBox="0 0 512 512">
          <path clip-rule="evenodd" d="m128 32c-53.0193 0-96 42.9807-96 96v256c0 53.019 42.9807 96 96 96h256c53.019 0 96-42.981 96-96v-256c0-53.0193-42.981-96-96-96zm48 112c0-13.255-10.745-24-24-24s-24 10.745-24 24v224c0 13.255 10.745 24 24 24s24-10.745 24-24zm64-24c-13.255 0-24 10.745-24 24v224c0 13.255 10.745 24 24 24h32c75.111 0 136-60.889 136-136s-60.889-136-136-136zm24 224v-176h8c48.601 0 88 39.399 88 88s-39.399 88-88 88z" fill-rule="evenodd"/>
        </symbol>
        <symbol id="icon-job" viewBox="0 0 32 32">
          <g id="Layer_38" data-name="Layer 38"><path d="m26 20.1v-4.1a1 1 0 0 0 -1-1h-8v-3.1a5 5 0 1 0 -2 0v3.1h-8a1 1 0 0 0 -1 1v4.1a5 5 0 1 0 2 0v-3.1h16v3.1a5 5 0 1 0 2 0z"/></g>
        </symbol>
        <symbol id="icon-birth" viewBox="0 0 561 561">
          <g id="cake"><path d="M280.5,114.75c20.4,0,38.25-17.85,38.25-38.25c0-7.65-2.55-12.75-5.1-20.4L280.5,0l-33.15,56.1c-2.55,5.1-5.1,12.75-5.1,20.4C242.25,96.9,260.1,114.75,280.5,114.75z M446.25,178.5H306v-38.25h-51v38.25H114.75C51,178.5,0,229.5,0,293.25c0,40.8,20.4,73.95,51,94.35V561h459V387.6c30.6-20.399,51-56.1,51-94.35C561,229.5,510,178.5,446.25,178.5z M446.25,357c-17.85,0-33.15-7.65-45.9-17.85L362.1,300.9l-38.25,38.25C313.65,349.35,298.35,357,280.5,357c-17.85,0-33.15-7.65-45.9-17.85l-38.25-38.25l-38.25,38.25C147.9,349.35,132.6,357,114.75,357C79.05,357,51,328.95,51,293.25s28.05-63.75,63.75-63.75h331.5c35.7,0,63.75,28.05,63.75,63.75S481.95,357,446.25,357z"/></g>
        </symbol>
        <symbol id="icon-email" viewBox="00 0 510 510">
          <g id="email"><path d="M459,51H51C22.95,51,0,73.95,0,102v306c0,28.05,22.95,51,51,51h408c28.05,0,51-22.95,51-51V102C510,73.95,487.05,51,459,51z M459,153L255,280.5L51,153v-51l204,127.5L459,102V153z"/></g>
        </symbol>
        <symbol id="icon-tel" viewBox="0 0 459 459">
          <g id="settings-phone"><path d="M433.5,318.8c-30.6,0-61.2-5.1-91.8-15.3c-7.6-2.5-17.9,0-25.5,5.1l-56.1,56.1c-71.4-35.7-130.1-96.9-168.3-168.3l56.1-56.1c7.6-7.6,10.2-17.8,5.1-25.5c-7.6-28.1-12.8-58.7-12.8-89.2c0-15.3-10.2-25.5-25.5-25.5H25.5C10.2,0,0,10.2,0,25.5C0,265.2,193.8,459,433.5,459c15.3,0,25.5-10.2,25.5-25.5v-89.2C459,329,448.8,318.8,433.5,318.8z"/></g>
        </symbol>
        <symbol id="icon-calender" viewBox="0 0 510 510">
            <g id="today"><path d="M433.5,51H408V0h-51v51H153V0h-51v51H76.5c-28.05,0-51,22.95-51,51v357c0,28.05,22.95,51,51,51h357c28.05,0,51-22.95,51-51V102C484.5,73.95,461.55,51,433.5,51z M433.5,459h-357V178.5h357V459z"/><rect x="127.5" y="229.5" width="127.5" height="127.5"/></g>
        </symbol>
        <symbol id="icon-report" viewBox="0 0 426.667 426.667">
          <g><path d="M384,85.333H213.333l-42.667-42.667h-128c-23.573,0-42.453,19.093-42.453,42.667L0,341.333C0,364.907,19.093,384,42.667,384H384c23.573,0,42.667-19.093,42.667-42.667V128C426.667,104.427,407.573,85.333,384,85.333zM277.333,149.333C300.907,149.333,320,168.427,320,192c0,23.573-19.093,42.667-42.667,42.667c-23.573,0-42.667-19.093-42.667-42.667C234.667,168.427,253.76,149.333,277.333,149.333z M362.667,320H192v-21.333c0-28.48,56.853-42.667,85.333-42.667s85.333,14.187,85.333,42.667V320z"/></g>
        </symbol>
      </defs>
    </svg>
    <a-layout>
      <!--   头部   -->
      <a-layout-header style="border-bottom:1px solid #eeeeee;margin-top:10px;">
        <div class="container clearfix">
          <!--   Logo   -->
          <router-link tag="a" to="/">
            <div class="logo" style="display: inline-block;height:55px;width:200px;float:left;padding-top:3px;">
              <img src="@/assets/Icons/TeamIcon.svg" alt="logo" style="width:38px;height:38px;vertical-align:top;">
              <span style="">Diggo Team</span>
            </div>
          </router-link>
          <!--   搜索框   -->
          <div style="float:left;margin-left:131px;height:40px;position:relative;">
            <a-auto-complete
              v-model="searchName"
              style="float:left;width:365px;border-radius:24px;"
              placeholder="Search Name"
              spellcheck="false"
              @select="onNameSelect"
              @change="onNameChange"
            >
              <template slot="dataSource">
                <a-select-option 
                    v-for="item in searchList" 
                    :key="item.employee_id"
                    :value="`${item.employee_id},${item.nickname},${item.username}`">
                  <img v-if="item.profile_picture" :src="item.profile_picture" alt="" style="width:40px;height:40px;border-radius:50%;">
                  <img v-else src="@/assets/Images/defaultavatar.jpeg" alt="" style="width:40px;height:40px;border-radius:50%;">
                  <span style="margin-left:12px;">{{ item.nickname }}</span>
                </a-select-option>
              </template>
              <a-input>
              </a-input>
            </a-auto-complete>
            <svg width="16" height="16" fill="#1659c4" style="position:absolute;right:14px;top:12px;z-index:99;cursor:pointer;"><use xlink:href="#icon-search"></use></svg>
          </div>
          <div style="width:40px;height:40px;float: right;border-radius: 50%;cursor: pointer" @click="backToReport">
            <img :src="avatar" alt="" style="width:100%;height:100%;border-radius: 50%;margin-bottom:26px;">
          </div>
          <router-link tag="a" to="/structure" target="_blank">
            <div class="team-structure">
              <svg width="20" height="20" fill="#1659c4" class="menu-open">
                <use xlink:href="#icon-team" ></use>
              </svg>
              <span>Team Structure</span>
            </div>
          </router-link>
        </div>
      </a-layout-header>
      <!--   内容   -->
      <a-layout-content>
        <!--   信息页   -->
        <div class="container">
          <a-spin :spinning="infoSpinning" style="width:100%;">
            <div class="info" style="width:100%;display:flex;flex-direction:column;">
              <!--   个人简介   -->
              <div class="info-prof">
                <div class="info-prof-avatar">
                  <!--                  <img :src="userInfoList.profile_picture" style="">-->
                  <img v-if="userInfoList.profile_picture" :src="userInfoList.profile_picture" alt="">
                  <img v-else src="@/assets/Images/defaultavatar.jpeg" alt="">
                </div>
                <div style="margin-left:23px;display:flex;flex-direction:column;justify-content:center;">
                  <div class="info-prof-name">{{ userInfoList.nickname }}</div>
                  <div class="info-prof-offer">{{ userInfoList.job_title }}
                    <span>- {{ userInfoList.group_name }}</span>
                  </div>
                </div>
              </div>
              <!--   个人信息   -->
              <div class="info-content" style="margin-top:24px;display:flex;">
                <div class="info-content-main" style="width:800px;display:flex;flex-direction:column;">
                  <!-- <div class="info-content-main-work" style="border-radius:16px;display:flex;align-items:center;">
                    <div class="info-content-main-work-title">The Main Work</div>
                    <div class="info-content-main-work-okr">
                      <div class="okr">
                        <div class="okr-logo"><img src="@/assets/Icons/personal-okr.svg" alt=""></div>
                        <a class="okr-href" :href="userInfoList.individual_okr" target="_blank">
                          <div class="okr-href-title">Personal OKR</div>
                        </a>
                      </div>
                      <div class="okr">
                        <div class="okr-logo"><img src="@/assets/Icons/team-okr.svg" alt=""></div>
                        <a v-if="teamOkr" class="okr-href" :href="teamOkr" target="_blank">
                          <div class="okr-href-title">Team OKR</div>
                        </a>
                        <a v-else class="okr-href" href="javascript:;">
                          <div class="okr-href-title">Team OKR</div>
                        </a>
                      </div>
                    </div>
                  </div> -->
                  <div class="info-content-main-work" style="height:168px;border:1px solid #e8e8e8;border-radius:16px;">
                    <div style="display:flex;align-items:center;justify-content:space-between;margin-top:20px;">
                      <div class="info-content-main-work-title">Core Work</div>
                      <div v-if="okrBtnVisible" class="link_btn" @click="linkChange">
                        Edit Link
                        <!-- <svg width="16" height="16" fill="#ffffff" style="margin-left:25px;margin-top:12px;"><use xlink:href="#icon-edit"></use></svg>
                        <span class="edit">Edit Link</span> -->
                      </div>
                    </div>
                    <a-modal 
                      title="OKR Href Modification"
                      :visible="linkVisible"
                      :dialog-style="{ top: '50%', marginTop: '-300px'}"
                      okText="OK"
                      cancelText="Cancel"
                      :confirm-loading="okrChangeConfirmLoading"
                      width="600px"
                      @ok="linkHandleOk"
                      @cancel="linkHandleCancel"
                    >
                      <div style="margin-bottom:20px;">
                        <div>Personal OKR:</div>
                        <a-input
                          style="margin-top:10px;"
                          v-model="personalOkrHref"
                        ></a-input>
                      </div>
                      <div @click="teamOkrTip">
                        <div>Team OKR:</div>
                        <a-input
                          :disabled="!teamOkrAdmin"
                          style="margin-top:10px;"
                          v-model="teamOkrHref"
                        ></a-input>
                      </div>
                    </a-modal>
                    <div class="info-content-main-work-okr">
                      <div class="okr" style="margin-right:23px;">
                        <div class="okr-logo"><img src="@/assets/Icons/personal-okr.svg" alt=""></div>
                        <a class="okr-href" :href="userInfoList.individual_okr" target="_blank">
                          <div class="okr-href-title">Personal OKR ( {{this.todayDate.split('-')[0]}} Q{{toQuarter(Number(this.todayDate.split('-')[1]))}} )</div>
                        </a>
                      </div>
                      <div class="okr">
                        <div class="okr-logo"><img src="@/assets/Icons/team-okr.svg" alt=""></div>
                        <a v-if="teamOkr" class="okr-href" :href="teamOkr" target="_blank">
                          <div class="okr-href-title">Team OKR ( {{this.todayDate.split('-')[0]}} Q{{toQuarter(Number(this.todayDate.split('-')[1]))}} )</div>
                        </a>
                        <a v-else class="okr-href" href="javascript:;">
                          <div class="okr-href-title">Team OKR ( {{this.todayDate.split('-')[0]}} Q{{toQuarter(Number(this.todayDate.split('-')[1]))}} )</div>
                        </a>
                      </div>
                    </div>
                  </div>
                  <!--   其他信息   -->
                  <div class="info-other">
                    <!-- <div class="info-other-left" style="display:flex;flex-direction: column"></div> -->
                    <div class="info-other-item" v-if="userInfoList.username !== 'alan' && userInfoList.username !== 'leslie'" style="margin-bottom:24px;">
                      <div class="info-other-item-title" style="padding-left:24px;">Managers</div>
                      <div class="info-other-item-content">
                        <div class="structure-item" style="margin-right:-80px;margin-top:9px;margin-left:58px;cursor:pointer;" @click="getStructureInfo('alan')" >
                          <div class="structure-item-content">
                            <div style="text-align:right;">Alan</div>
                            <span>Chief Operation Officer</span>
                          </div>
                          <img style="margin-left:11px;" src="@/assets/Images/defaultavatar.jpeg" alt="">
                        </div>
                        <a-timeline>
                          <a-timeline-item  style="cursor:pointer" 
                                            v-for="item in userInfoList.structure"
                                            :key="item.manager_ee_id" 
                                            @click="getStructureInfo(item.username)">
                            <div class="structure-item">
                              <img v-if="item.profile_picture" :src="item.profile_picture" alt="">
                              <img v-else src="@/assets/Images/defaultavatar.jpeg" alt="">
                              <div class="structure-item-content">
                                <div>{{ item.nickname }}</div>
                                <span>{{ item.job_title }}</span>
                              </div>
                            </div>
                          </a-timeline-item>
                          <a-timeline-item v-if="userInfoList.username !== 'alan'" style="cursor:pointer" @click="getStructureInfo(userInfoList.username)">
                            <div class="structure-item">
                              <img v-if="userInfoList.profile_picture" :src="userInfoList.profile_picture" alt="">
                              <img v-else src="@/assets/Images/defaultavatar.jpeg" alt="">
                              <div class="structure-item-content">
                                <div>{{ userInfoList.nickname }}</div>
                                <span>{{ userInfoList.job_title }}</span>
                              </div>
                            </div>
                          </a-timeline-item>
                        </a-timeline>
                      </div>
                    </div>
                    <div class="info-other-item" style="margin-bottom:24px;" v-if="nextStructureStatus">
                        <div class="info-other-item-title" style="padding-left:24px;">Reports</div>
                        <div class="info-other-item-report">
                          <a-list>
                            <div slot="header" style="padding-left:24px;">
                              <div class="info-other-item-report-header">
                                <span>Name</span>
                              </div>
                            </div>
                            <a-list-item v-for="item in userInfoList.next_structure" :key="item.employee_id" style="padding:0 0 0 8px;">
                              <div class="structure-item" style="margin-top:0;width:320px;cursor:pointer;" @click="getStructureInfo(item.username)">
                                <img v-if="item.profile_picture" :src="item.profile_picture" alt="">
                                <img v-else src="@/assets/Images/defaultavatar.jpeg" alt="">
                                <div class="structure-item-content">
                                  <div>{{ item.nickname }}</div>
                                  <span>{{ item.job_title }}</span>
                                </div>
                              </div>
                            </a-list-item>
                          </a-list>
                        </div>
                    </div>
                    <div class="info-other-item" style="display:flex;flex-direction:column;position:relative;margin-bottom:24px;align-items:flex-end;">
                      <div class="info-other-item-title">Fun Facts About Myself</div>
                      <a-textarea
                        placeholder="Empty Profile"
                        spellcheck="false"
                        class="info-other-item-profile"
                        :value="this.userInfoList.profile_content"
                        :disabled="true"
                      />
                      <div v-if="profileBtnVisible" class="profile_btn" @click="profileChange">
                        <svg width="16" height="16" fill="#1659c4" style=""><use xlink:href="#icon-edit"></use></svg>
                        <span class="edit">Edit Content</span>
                      </div>
                    </div>
                    <a-modal
                      title="Personal Profile Modification"
                      :visible="profileVisible"
                      :dialog-style="{ top: '50%', marginTop: '-300px'}"
                      okText="OK"
                      cancelText="Cancel"
                      width="600px"
                      @ok="profileHandleOk"
                      @cancel="profileHandleCancel"
                    >
                      <a-textarea
                        placeholder="Personal Profile"
                        spellcheck="false"
                        style="width:600px;height:200px;resize:none;"
                        v-model="personalProfile"
                      />
                    </a-modal>
                  </div>
                </div>
                <div class="info-content-aside">
                  <div class="info-content-information">
                    <div class="info-content-information-title">Personal Information</div>
                    <div class="info-content-information-item">
                      <div class="info-content-information-item-title">
                         <svg width="20" height="20" fill="#1659c4" class="menu-open">
                            <use xlink:href="#icon-time" ></use>
                          </svg>
                      </div>
                      <div class="info-content-information-item-content">{{ workYear }} {{workYearStatus}}
                        ({{ moment(userInfoList.onboard_date).format('MM-DD-YYYY') }})
                      </div>
                    </div>
                    <div class="info-content-information-item">
                     <div class="info-content-information-item-title">
                         <svg width="20" height="20" fill="#1659c4" class="menu-open">
                            <use xlink:href="#icon-fte" ></use>
                          </svg>
                      </div>
                      <div class="info-content-information-item-content">{{ userInfoList.employee_id }} -
                        {{ userInfoList.ee_type === '0' ? 'FTE' : userInfoList.ee_type === '1' ? 'onsite intern' : 'offsite intern' }}
                      </div>
                    </div>
                    <div class="info-content-information-item">
                      <div class="info-content-information-item-title">
                        <svg width="20" height="20" fill="#1659c4" class="menu-open">
                          <use xlink:href="#icon-job" ></use>
                        </svg>
                      </div>
                      <div class="info-content-information-item-content">{{ userInfoList.job_title }}</div>
                    </div>
                    <div class="info-content-information-item">
                      <div class="info-content-information-item-title">
                        <svg width="20" height="20" fill="#1659c4" class="menu-open">
                          <use xlink:href="#icon-birth" ></use>
                        </svg>
                      </div>
                      <div class="info-content-information-item-content">{{ userInfoList.birthday }}</div>
                    </div>
                  </div>
                  <div class="info-content-main-details">
                    <div class="info-content-main-details-contact">
                      <div class="title">Contact Details</div>
                      <div class="item">
                        <svg width="20" height="20" fill="#1659c4" class="menu-open">
                          <use xlink:href="#icon-email" ></use>
                        </svg>
                        <span>{{ userInfoList.email_address }}</span>
                        <div class="copy" @click="copy(userInfoList.email_address )">Copy</div>
                      </div>
                      <div class="item">
                        <svg width="20" height="20" fill="#1659c4" class="menu-open">
                          <use xlink:href="#icon-tel" ></use>
                        </svg>
                        <span style="letter-spacing: -1px;">{{ this.tel_1 }}&nbsp;&nbsp;{{ tel_2 }}&nbsp;&nbsp;{{ tel_3 }}</span>
                        <div class="copy" @click="copy(userInfoList.mobile_number)">Copy</div>
                      </div>
                    </div>
                    <div class="info-content-main-details-working">
                      <div class="title">Working Status</div>
                      <div class="item">
                        <svg width="20" height="20" fill="#1659c4" class="menu-open">
                          <use xlink:href="#icon-calender" ></use>
                        </svg>
                        <a
                          v-bind:href="'https://calendar.google.com/calendar/embed?&wkst=2&src='+ userInfoList.username +'%40impr-inc.com&ctz=Asia%2FShanghai&mode=WEEK'"
                          target="_blank">Click to view calender</a>
                      </div>
                      <div class="item">
                        <svg width="20" height="20" fill="#1659c4" class="menu-open">
                          <use xlink:href="#icon-report" ></use>
                        </svg>
                        <!-- 工作报告跳转 -->
                        <a target="_blank" v-bind:href="'/snippets/' + userInfoList.username">Click to view work report</a>
                      </div>
                    </div>
                  </div>
                  
                  <div class="info-other-item" style="height:180px;margin-top:24px;margin-left:32px;width:368px;">
                      <div class="info-other-item-title">True Color <a href="https://color.diggo-inc.com/" target="_blank" class="test-color">(Test Again)</a></div>
                      <div class="info-other-item-colors" style="display: flex;padding-left: 25px;padding-right: 25px;justify-content: flex-start;">
                        <div class="colors-left">
                          <div class="color-item">
                            <div :style="{backgroundColor:'#5a9ae9', width: blueWidth}"></div>
                            <span>{{ blueNum }}</span>
                          </div>
                          <div class="color-item">
                            <div :style="{backgroundColor:'#ffd700', width: goldWidth}"></div>
                            <span>{{ goldNum }}</span>
                          </div>
                          <div class="color-item">
                            <div :style="{backgroundColor:'#79d292', width: greenWidth}"></div>
                            <span>{{ greenNum }}</span>
                          </div>
                          <div class="color-item">
                            <div :style="{backgroundColor:'#ffa501', width: orangeWidth}"></div>
                            <span>{{ orangeNum }}</span>
                          </div>
                        </div>
                        <div class="colors-right" :style="'background: linear-gradient(' + trueColor + ',' + trueColor + ')'">
                          <div class="colors-right-text">
                            <div :style="'color:' + trueColor[0]">{{ trueColorText.split(' ')[0] }}</div>
                            <div :style="'color:' + trueColor[1]">{{ trueColorText.split(' ')[1] }}</div>
                            <div :style="'color:' + trueColor[2]">{{ trueColorText.split(' ')[2] }}</div>
                            <div :style="'color:' + trueColor[3]">{{ trueColorText.split(' ')[3] }}</div>
                          </div>
                        </div>
                      </div>
                    </div>
                </div>
              </div>
            </div>
          </a-spin>
        </div>
      </a-layout-content>

      <!--   底部   -->
      <!--      <a-layout-footer>-->
      <!--        <div class="container">Footer</div>-->
      <!--      </a-layout-footer>-->
    </a-layout>
    <Bug></Bug>
  </div>
</template>

<script>
import moment from 'moment'
import api from '@/common/api.js'
import Bug from '../../components/Bug.vue'

moment.suppressDeprecationWarnings = true

let colorList = ['#5a9ae9', '#ffd700', '#79d292', '#ffa501']
let colorTextList = ['Blue', 'Gold', 'Green', 'Orange']
export default {
  name: 'Information',
  components:{
    Bug
  },
  inject: ['reload'],
  data() {
    return {
      id: '',
      moment,                             //  日期
      todayDate: moment()                 //  今天日期
      .format()
      .slice(0, 10),
      infoSpinning: false,                //  员工信息页加载状态
      colorList,                          //  颜色列表
      colorTextList,                      //  颜色名称列表
      //  搜索框
      searchName: '',                     //  搜索人名
      searchList: [],                     //  搜索下拉框内容

      //  True Colors
      blueNum: '',                        //  蓝色数值
      goldNum: '',                        //  黄色数值
      greenNum: '',                       //  绿色数值
      orangeNum: '',                      //  橘色数值
      blueWidth: '',                      //  蓝色宽度
      goldWidth: '',                      //  黄色宽度
      greenWidth: '',                     //  绿色宽度
      orangeWidth: '',                    //  橘色宽度
      trueColor: '',                      //  主要颜色
      trueColorText: '',                  //  主要颜色名称

      //  个人资料
      userList: '',                       //  员工列表
      curUserId: '',                      //  当前员工编号
      avatar: '',                         //  当前员工头像
      searchUserId: '',                   //  查找员工编号
      userInfoList: '',                   //  个人所有资料
      tel: '',                            //  个人电话
      tel_1: '',                          //  号码分解
      tel_2: '',
      tel_3: '',
      teamOkr: '',                        //  团队OKR链接
      profileVisible: false,              //  个人资料修改框
      personalProfile: '',                //  个人资料
      linkVisible:false,                  //  okr框显示
      okrChangeConfirmLoading:false,      //  修改okr确认状态
      personalOkrHref:'',                 //  修改个人okr链接
      teamOkrHref:'',                     //  修改团队okr链接
      groupLeader:'',                     //  小组负责人id
    }
  },
  computed: {
    //  工龄计算
    workYear: function () {        
      return this.userInfoList.resignation_date == null ? ((moment(this.todayDate).diff(this.userInfoList.onboard_date) / (1000 * 60 * 60 * 24)) / 365).toFixed(2) : ((moment(this.userInfoList.resignation_date).diff(this.userInfoList.onboard_date) / (1000 * 60 * 60 * 24)) / 365).toFixed(2)
    },
    workYearStatus: function() {
      return this.workYear <= 1 ? 'Year' : 'Years'
    },
    // 编辑按钮显示
    profileBtnVisible: function () {
      return this.curUserId === this.searchUserId
    },
    // okr编辑按钮显示
    okrBtnVisible: function () {
      return this.curUserId === this.searchUserId
    },
    // 团队编辑框权限
    teamOkrAdmin: function() {
      return this.curUserId === this.groupLeader
    },
     // 是否有汇报人
    nextStructureStatus: function() {
      return this.userInfoList.next_structure && this.userInfoList.next_structure.length != 0
    }

    
  },
  watch: {
    '$route'() {
      // if(this.$route.query.username == undefined) {
      //   this.searchUserId = this.curUserId
      // }else {
      //   this.userList.filter(item => {
      //     if(this.$route.query.username == item.username) {
      //       this.searchUserId = item.employee_id
      //     }
      //   })
      // }
      if(this.$route.params.name == undefined) {
        this.searchUserId = this.curUserId
      }else {
        this.userList.filter(item => {
          if(this.$route.params.name == item.username) {
            this.searchUserId = item.employee_id
          }
        })
      }
      this.getUserInfo()
    }
  },
  methods: {

    toQuarter(month) {
      if (month >= 1 && month <= 3) {
        return 1; // 第一季度
      } else if (month >= 4 && month <= 6) {
        return 2; // 第二季度
      } else if (month >= 7 && month <= 9) {
        return 3; // 第三季度
      } else if (month >= 10 && month <= 12) {
        return 4; // 第四季度
      }
    },

    //  输入框内容改变 过滤名单
    onNameChange(name) {
      if (name == '') {
        this.searchList = []
      } else {
        this.searchList = this.userList.filter(item => {
          return item.username.indexOf(name.toLowerCase()) != -1 || item.legal_name.indexOf(name) != -1
        })
      }
    },
    //  选择后查询更改查询id 发起请求
    onNameSelect(info) {
      this.searchUserId = info.split(',')[0]
      this.searchName = info.split(',')[1]
      //  发起请求
      this.urlPathLink(info.split(',')[2])
    },
    // 获取员工列表
    getUserList() {
      this.$post(api.tool.getUserList, {
        timestamp: Date.parse(new Date()),
        token: localStorage.impr_token,
        employee_id: this.curUserId,
      }).then((res) => {
        if (res.code === 200) {
          this.userList = res.list
          if(this.$route.params.name == undefined) {
            this.searchUserId = this.curUserId
          }else {
            this.userList.filter(item => {
              if(this.$route.params.name == item.username) {
                this.searchUserId = item.employee_id
              }
            })
          }
          this.getUserInfo()
        }
      })
    },
    // 获取员工信息
    getUserInfo() {
      this.infoSpinning = true
      this.$post(api.tool.getUserInfo, {
        timestamp: Date.parse(new Date()),
        token: localStorage.impr_token,
        employee_id: this.curUserId,
        ee_id: this.searchUserId
      }).then((res) => {
        if (res.code === 200) {
          this.userInfoList = res.list
          this.teamOkr = this.userInfoList.group_okr
          this.groupLeader = this.userInfoList.group_leader
          this.infoSpinning = false
          this.personalProfile = this.userInfoList.profile_content
          this.telphoneInit()
          this.colorWidthInit()
        }
      })
    },
    //  通过结构点击查看信息
    getStructureInfo(userName) {
      this.urlPathLink(userName)
    },
    //  个人资料修改框
    profileChange() {
      this.profileVisible = true
    },
    // 确定修改
    profileHandleOk() {
      this.profileVisible = false
      //  发起请求
      // console.log(this.personalProfile)
      this.$post(api.tool.updateUserIntro, {
        timestamp: Date.parse(new Date()),
        token: localStorage.impr_token,
        employee_id: this.curUserId,
        profile_content: this.personalProfile
      }).then((res) => {
        if (res.code === 200) {
          // console.log(res)
          this.getUserInfo()
        }
      })
    },
    // 取消修改
    profileHandleCancel() {
      this.profileVisible = false
    },
    //  电话号码处理
    telphoneInit() {
      this.tel_1 = this.userInfoList.mobile_number.substring(0, 3)
      this.tel_2 = this.userInfoList.mobile_number.substring(3, 7)
      this.tel_3 = this.userInfoList.mobile_number.substring(7, 11)
    },
    //  颜色宽度计算初始化
    colorWidthInit() {
      if (this.userInfoList.color == null) {
        this.blueNum = '0'
        this.goldNum = '0'
        this.greenNum = '0'
        this.orangeNum = '0'

        this.trueColor = '#f2f4f5'
        this.trueColorText = ''
      } else {
        this.blueNum = this.userInfoList.color.blue
        this.goldNum = this.userInfoList.color.gold
        this.greenNum = this.userInfoList.color.green
        this.orangeNum = this.userInfoList.color.orange

        //  颜色值数组 最大值 对应索引 从colorList colorTextList中提取
        //  最高值可能并列，收集所有并列的颜色和名称
        let colorArr = [this.blueNum, this.goldNum, this.greenNum, this.orangeNum]
        let colorMax = Math.max(...colorArr)
        this.trueColor = []
        this.trueColorText = ''
        colorArr.forEach((item, index) => {
          if (item == colorMax) {
            this.trueColor.push(this.colorList[index])
            this.trueColorText = this.trueColorText + this.colorTextList[index] + ' '
          }
        })
      }

      this.blueWidth = (this.blueNum / 20 * 100) + '%'
      this.goldWidth = (this.goldNum / 20 * 100) + '%'
      this.greenWidth = (this.greenNum / 20 * 100) + '%'
      this.orangeWidth = (this.orangeNum / 20 * 100) + '%'

    },
    //  回到自己页面
    backToReport() {
      this.$router.push({ path: '/team'})
    },
    // 通过链接跳转
    urlPathLink(username){
      this.$router.push({ path: '/team/' + username })
    },
    // 链接修改弹框
    linkChange() {
      this.linkVisible = true
      this.personalOkrHref = this.userInfoList.individual_okr
      this.teamOkrHref = this.teamOkr
    },
    // 确定修改链接
    linkHandleOk() {
      this.okrChangeConfirmLoading = true
      // console.log(this.personalOkrHref)
      // console.log(this.teamOkrHref)

      // 发送请求修改
      this.$post(api.tool.updateOkr, {
        timestamp: Date.parse(new Date()),
        token: localStorage.impr_token,
        employee_id: this.curUserId,
        individual_okr:this.personalOkrHref,
        group_okr:this.teamOkrHref
      }).then((res) => {
        if (res.code === 200) {
          this.okrChangeConfirmLoading = false
          this.linkVisible = false
          this.$message.success('修改成功')
          this.getUserInfo()
        }
      })

    },
    // 取消修改链接
    linkHandleCancel(){
      this.linkVisible = false
    },
    // teamOKR修改提示
    teamOkrTip() {
      if(!this.teamOkrAdmin) {
        this.$message.error("您不是小组负责人，无法修改小组 OKR 链接")
      }
    },
    // 复制功能
    copy(value) {
      navigator.clipboard.writeText(value).then(function() {})
      this.$message.success('复制成功')
    }
  },
  created() {
    // console.log(this.$route.params.name)
    if (localStorage.impr_id && localStorage.impr_token) {
      this.avatar = localStorage.impr_picture
      this.curUserId = localStorage.impr_id
      this.searchUserId = localStorage.impr_id

      this.getUserList()
    } else {
      this.$router.push({ path: '/login' })
    }
  },

}
</script>

<style scoped>
/* Common */
#components-layout-demo-basic .ant-layout {
  background: #fff;
}
#components-layout-demo-basic .ant-layout-header,
#components-layout-demo-basic .ant-layout-footer {
  height: 55px;
  padding: 0;
  background: #fff;
  color: #000;
}
#components-layout-demo-basic .ant-layout-content {
  background: #fff;
  color: #fff;
  min-height: 1145px;
}
.container {
  /*width: 60%;*/
  width: 1198px;
  height: 100%;
  margin: 0 auto;
  display: flex;
  color: #000;
}
.clearfix {
  content: '';
  display: block;
  clear: both;
}

/* Logo */
.logo span {
  line-height: 38px;
  margin-left: 10px;
  vertical-align: top;
  font-family: GoogleSans-Medium;
  font-size: 20px;
  font-weight: normal;
  font-stretch: normal;
  color: #1659c4;
}
#components-layout-demo-basic >>> .ant-input {
  height: 40px;
  border-radius: 24px;
  background-color: #f1f3f4;
  font-size: 14px;
  border: none;
}
#components-layout-demo-basic >>> .ant-input::placeholder {
  font-size: 14px;
  color: #aaaaaa;
}
/* Avatar Name Offer */
.info-prof {
  height: 96px;
  margin-top: 40px;
  display: flex;
}
.info-prof-avatar {
  width: 96px;
  height: 96px;
}
.info-prof-avatar img {
  width: 100%;
  height: 100%;
  border-radius: 50%;
}
.info-prof-name {
  font-family: GoogleSans-Regular;
  font-size: 28px;
  line-height: 40px;
  color: #000;
}
.info-prof-offer {
  font-family: GoogleSans-Regular;
  font-size: 14px;
  line-height: 20px;
  color: rgba(0,0,0,0.54);
}
/* The Main Work */
.info-content-main-work-title {
  height:16px;
  font-family: GoogleSans-Regular;
  font-size: 12px;
  line-height: 19px;
  color: rgba(0,0,0,0.54);
  margin-left: 25px;
}
.info-other-item-title {
  color: rgba(0,0,0,0.54);
}
.info-content-main-work-okr {
  width:100%;
  display: flex;
  justify-content: center;
  margin-top:14px;
}
/* OKR */
.okr {
  width: 364px;
  height: 88px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  padding-left: 35px;
  border: solid 2px #dddddd;
}
.okr:hover {
  border: solid 2px #1659c4;
  background-color: #f8fbfe;
}
.okr-logo {
  width: 40px;
  height: 40px;
}
.okr-logo img {
  width: 100%;
  height: 100%;
}
.okr-href {
  display: flex;
  flex-direction: column;
  margin-left: 15px;
  color: #222222;
}
.okr-href-title {
  height: 17px;
  font-family: Roboto-Bold;
  font-size: 18px;
  line-height: 19px;
}
.okr-href span {
  height: 12px;
  font-family: GoogleSans-Regular;
  font-size: 14px;
  line-height: 19px;
  color: #222222;
  opacity: 0.5;
  margin-top: 9px;

}
.okr-href:hover .okr-href-title {
  color: #1659c4;
}

/* Details */
.info-content-main-details {
  width:368px;
  margin-left: 32px;
}
.info-content-main-details-contact,
.info-content-main-details-working {
  border: 1px solid #e8e8e8;
  border-radius: 16px;
  display: flex;
  flex-direction: column;
  padding: 24px;
  margin-bottom:24px;
}

.info-content-main-details .title {
  height: 16px;
  font-family: GoogleSans-Regular;
  font-size: 12px;
  line-height: 16px;
  color: rgba(0,0,0,0.54);
}
.info-content-main-details .item {
  display: flex;
  align-items: center;
  height: 17px;
  margin-top: 25px;
}
.info-content-main-details .item img {
  width: 20px;
  height: 20px;
  margin-bottom: 4px;
}
.info-content-main-details .item img.share {
  width: 14px;
  height: 14px;
  margin-left: 8px;
  margin-bottom: 3px;
}
.info-other-item-title img.share {
  width: 14px;
  height: 14px;
  margin-left: 2px;
  margin-bottom: 1px;
}
.info-content-main-details .item span {
  font-family: Roboto-Regular;
  font-size: 14px;
  line-height: 15px;
  color: #000000;
  margin-left: 24px;
}
.copy {
  display: inline-block;
  width: 54px;
	/* height: 32px; */
  line-height:16px;
  text-align: center;
  cursor: pointer;
	font-family: Roboto-Medium;
	font-size: 14px;
	color: #1659c4;
  margin-left: auto;
}
.copy:hover {
  background-color: #f2f3f4;
	border-radius: 6px;
}
.info-content-main-details .item a {
  font-family: Roboto-Medium;
  font-size: 14px;
  display: inline-block;
  line-height: 16px;
  padding:0 10px;
  color: #1659c4;
  margin-left: 15px;
}
.info-content-main-details .item a:hover {
  background-color: #f2f3f4;
	border-radius: 6px;
}

/* Personal Information */
.info-content-information {
  padding-left: 24px;
  width:368px;
  margin-left: 32px;
  border: 1px solid #e8e8e8;
  border-radius: 16px;
  display: flex;
  flex-direction: column;
  margin-bottom:24px;
  padding-bottom:24px;
  padding-top:24px;
}
.info-content-information-title {
  height: 16px;
  font-family: GoogleSans-Regular;
  font-size: 12px;
  line-height: 16px;
  color: rgba(0,0,0,0.54);
  margin-bottom: -5px;
}
.info-content-information-item {
  display: flex;
  align-items: center;
  margin-top: 30px;
}
.info-content-information-item-title {
  height: 20px;
}
.info-content-information-item-content {
  font-family: Roboto-Regular;
  font-size: 14px;
  line-height: 16px;
  color: #000000;
  margin-left:24px;
}

/* Other */
.info-other {
  width: 800px;
  margin-top: 24px;
  display: flex;
  flex-direction: column;
}
.info-other-item {
  /* width: 368px; */
  border-radius: 16px;
  border: 1px solid #e8e8e8;
}

/* Other Colors */
.colors-left {
  width: 196px;
  /* width:80%; */
  display: flex;
  flex-direction: column;
  margin-top: 19px;
}
.color-item {
  /* width: 202px; */
  height: 12px;
  background-color: #f2f4f5;
  border-radius: 6px;
  margin-top: 12px;
  position: relative;
}
.color-item div {
  height: 100%;
  border-radius: 6px;
}
.color-item span {
  height: 11px;
  width:15px;
  font-family: Roboto-Regular;
  font-size: 14px;
  line-height: 19px;
  letter-spacing: -2px;
  color: rgba(0,0,0,0.87);
  position: absolute;
  top: -3px;
  left:104%;

}
.colors-right {
  width: 82px;
  height: 82px;
  border-radius: 50%;
  margin-top: 31px;
  margin-left:40px;
}
.colors-right-text {
  width: 74px;
  height: 74px;
  border-radius: 50%;
  margin: 4px;
  background-color: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  font-family: Roboto-Medium;
  font-size: 16px;
}

/* Other Profile */
.info-other-item-title {
  height:16px;
  font-family: GoogleSans-Regular;
  font-size: 12px;
  line-height: 16px;
  color: rgba(0,0,0,0.54);
  margin-top: 24px;
  width:100%;
  padding-left:24px;
}
.test-color {
  font-family: Roboto-Regular;
  font-size: 12px;
  line-height: 16px;
  margin-left: 5px;
  color: #bbbbbb;
  cursor: pointer;
}
.test-color:hover {
  color: #2177e9;
}
#components-layout-demo-basic >>> .info-other-item-profile {
  width: 100%;
  height: 250px;
  font-family: GoogleSans-Regular;
  font-size: 14px;
  line-height: 24px;
  letter-spacing: 0px;
  color: #555555;
  background-color: #ffffff;
  border: 0;
  resize: none;
  margin-top: 25px;
  padding: 0;
  cursor: default;
  padding-left:24px;
}
.profile_btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 160px;
  height: 40px;
  border: solid 1px #dddddd;
  border-radius: 20px;
  margin-top:24px;
  margin-bottom:24px;
  cursor: pointer;
  margin-right:24px;
}
.profile_btn:hover {
  background-color: #f8fbfe;
	border: solid 1px #1659c4;
}
.link_btn {
  width:80px;
  text-align: center;
  font-family: GoogleSans-Medium;
  font-size: 15px;
  cursor: pointer;
  color: #1659c4;
  margin-right:24px;
  border-radius: 6px;
}
.link_btn:hover {
  background: #f2f3f4;
}

.profile_btn span{
  font-family: GoogleSans-Medium;
  font-size: 14px;
  color:#333333;
  margin-left: 13px;
}

/* Other Structure */
#components-layout-demo-basic >>> .ant-timeline {
  margin-top: 32px;
  margin-left: 25px;
  margin-bottom:-18px;
}
#components-layout-demo-basic >>> .ant-timeline-item {
  padding: 0 0 0;
}
#components-layout-demo-basic >>> .ant-timeline-item-tail {
  left: 5px;
  height: 70px;
}
#components-layout-demo-basic >>> .ant-timeline-item-head {
  width: 12px;
  height: 12px;
  background-color: #bbbbbb;
  border-color: #bbbbbb;
}
#components-layout-demo-basic >>> .ant-timeline-item-content {
  top: -32px;
}
#components-layout-demo-basic >>> .ant-timeline-item-last .ant-timeline-item-head {
  background-color: #555555;
  border-color: #555555;

}
.info-other-item-structure {
  margin-top: 11px;
  margin-left: 6px;
}
.structure-item {
  display: flex;
  align-items: center;
  width: 258px;
  height: 73px;
  margin-top: 7px;
}
.structure-item img {
  width: 36px;
  height: 36px;
  background-color: #5f6368;
  border-radius: 50%;
  margin-left: 18px;
}
.structure-item-content {
  height:100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-left: 11px;
}
.structure-item-content div {
  height: 14px;
  font-family: Roboto-Medium;
  font-size: 14px;
  line-height: 16px;
  color: rgba(0,0,0,0.87);
}
.structure-item-content span {
  height: 14px;
  font-family: Roboto-Regular;
  font-size: 12px;
  line-height: 16px;
  color: rgba(0,0,0,0.54);
  margin-top: 8px;
}
.team-structure {
  width:160px;
  height:40px;
  border-radius:20px;
  border:1px solid #dddddd;
  float: right;
  cursor: pointer;
  margin-right:24px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.team-structure:hover {
  border:1px solid #1659c4;
  background: #f8fbfe;
}
.team-structure:hover span {
  color:#1659c4;
}
.team-structure span{
  font-family: GoogleSans-Medium;
	font-size: 14px;
	line-height: 19px;
	color: #0a3266;
  margin-left:10px;
}

.info-other-item-content {
  display:flex;
  justify-content: center;
}
.info-other-item-report {
  margin-top:24px;
}
.info-other-item-report-header span {
  font-family: GoogleSans-Regular;
	font-size: 14px;
	color: rgba(0,0,0,0.54);
}

</style>
